import React from 'react'
import TextField from '@mui/material/TextField'
import { ModalInputFieldProps } from '../propsTypes'

const ModalInputField = ({ value, onChange, placeholder, disabled }: ModalInputFieldProps) => {
  return (
    <TextField
      placeholder={placeholder ?? ''}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled ?? false}
      sx={{
        width: '70%',
        '& .MuiOutlinedInput-root': {
          borderColor: 'transparent',
          color: '#fff',
          background: 'rgba(255, 255, 255, 0.05)',
          fontFamily: 'Space Grotesk, sans-serif',

          '& .Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.5)',
            background: 'rgba(255, 255, 255, 0.15)',
          },

          '&input:disabled': {
            color: 'rgba(255, 255, 255, 0.5)',
          },
        },
        '& .MuiFormHelperText-root': {
          color: '#fff',

          '&.Mui-error': {
            color: '#d32f2f',
          },
        },
      }}
    />
  )
}

export default ModalInputField
